import { createContext } from 'react';
export const EnrichmentSettingsContext = /*#__PURE__*/createContext(undefined);